<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import { orderStore } from "../../services/order-options-service";
  import { fileStore } from "../../services/select-files";
  import OptionRow from "./OptionRow.svelte";
  import { SearchState } from "../../services/search-service";

  const id = "enddate";
  export let option: OrderOption;

  // Default endDate
  orderStore.setOrderValue(id, [
    {
      id: id,
      value: $SearchState.params.get("endDate") ?? $fileStore.maxDate,
      selected: true
    }
  ]);
</script>

<OptionRow
  {id}
  label="End Date"
  tooltip="Edit the End Date by closing this modal and modifying the when input of your search."
>
  {#if $orderStore.options[id]}
    {#each $orderStore.values[id] as option}
      <div>{option.value}</div>
    {/each}
  {/if}
</OptionRow>
